import TargetLink from "@/components/TargetLink";
import styles from "@/styles/Informations.module.scss";

export default function InformationRow({ item }) {
  return (
    <div className={styles.row}>
      <div className={styles.section}>
        <div className={styles.inner}>
          <div className={styles.date}>{item.date}</div>
          <TargetLink
            className={styles.link}
            href={item.url}
            blank={item.targetBlank}
          >
            {item.title}
          </TargetLink>
        </div>
      </div>
    </div>
  );
}
